import px from 'vue-types'

export const pxOption = () => px.oneOf(['and', 'or']).def('or')
